import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import myIcon from '@app/assets/images/icons/fk/menu.svg';
import AutoCreateMenu from '@modules/school-service/pages/Foodkid/MenuGroup/AutoCreateMenuPage';
import CopyMenu from '@modules/school-service/pages/Foodkid/MenuGroup/CopyMenuPage';
import { IRouteConfig } from '../route.types';

/**
 * Thực đơn
 */
const foodkidRoutes: IRouteConfig[] = [
    {
        name: 'THỰC ĐƠN',
        icon: myIcon,
        isMenu: true,
        isRoute: false,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        children: [
            {
                name: 'Tạo thực đơn',
                link: '/foodkid',
                path: '/foodkid',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.FOODKID_CREATE_MENU,
                main: () => <AutoCreateMenu />,
            },
            {
                name: 'Sao chép thực đơn',
                link: '/copy-menu',
                path: '/copy-menu',
                isMenu: true,
                isRoute: true,
                exact: false,
                functionId: ADMIN_FUNCTIONS.FOODKID_COPY_MENU,
                main: () => <CopyMenu />,
            },
        ],
    },
];

export default foodkidRoutes;
